export default __webpack_public_path__ + "static/bike-1dad6b0f3281b4767c1025a2e4d1e89c.png";